<template>
  <div class="head-container">
    <div class="head-table2">
      <el-upload
        class="avatar-uploader"
        name="Filedata"
        action="http://sinograinadmin.7east.cn/f/app/uploadfile"
        :show-file-list="false"
        :on-change="uploadFile"
        :auto-upload="false"
      >
        <img :src="storeUserimg" class="headimg">
       <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
      </el-upload>
      <!-- <img src="../../../assets/img/head.png" class="headimg"> -->
      <div class="head-text">点击图片修改头像，你可以上传JPG、GIF或<br/>PNG格式的文件，文件大小不能超过2M。</div>
      <button class="headbtn" @click="changeHead">修改头像</button>
    </div>
  </div>
</template>

<script>
  import {ApichangeHead} from '../../../net/accound/index.js'
  import store from '../../../vuex/store.js'
  import {setCookie, getCookie, removeCookie} from '../../../untils/common.js'
	export default {
		data: function () {
			return {
        imageUrl: '',
        upUrl: '',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }
		},
    store,
    computed: {
      storeUserimg: function () {
        return this.imageUrl?this.imageUrl:this.$store.state.userImage
      }
    },
    methods: {
      changeHeadImg: function () {
        this.$store.commit('changeUserImg', this.imageUrl)
        const _user = getCookie('user')
        if (_user) {
          let user = JSON.parse(_user)
          user.userImage = this.imageUrl
          setCookie('user', JSON.stringify(user))
        }
      },
      changeHead: function () {
        ApichangeHead({image: this.upUrl}).then(res=>{
          if(res.code == 200){
            this.$message.success('头像修改成功')
            this.changeHeadImg()
          }
         // console.log('上传修改', res)
        })
      },
      uploadFile (file) {
        // this.imageUrl = file.raw // 拿到文件的信息
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return
        }
        //console.log('this.imageUrl', file.raw)
        var formData = new FormData()
        formData.append("Filedata", file.raw)
        // console.log('formData',formData)
        const _url = `http://sgnadmin.7east.cn/f/app/uploadfile`
        this.axios2.post(_url, formData).then((res)=>{
          if(res.data.code == 200) {
            this.upUrl = res.data.value
            this.imageUrl = `http://sgnbkt.oss-accelerate.aliyuncs.com${res.data.value}`
          }
        		//console.log('上传结果',res)
        }).catch(err=>{
        	 //console.log('上传失败',err)
        })
      }
    },
    mounted: function () {

    }
	}
</script>

<style scoped>
.head-container{
  width: 850px;
  height: 500px;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}
.head-table2{
  width: 300px;
  margin: 0 auto;
  margin-top:50px;
  text-align: center;
}
.headimg{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: none;
}
.head-text{
  color: #666;
  font-size: 12px;
  margin-top: 10px;
  line-height: 1.5;
  text-align: center;
}
.headbtn{
  border:none;
  width: 160px;
  height: 40px;
  text-align: center;
  color: #fff;
  background-color: #0AAC50;
  font-size: 16px;
  border-radius: 4px;
  margin-top: 20px;
  outline: none;
  border: 1px solid transparent;
}
.headbtn:hover{
  background: #019B3C;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AccSetting/children/avatar.vue